import React, { Fragment, useEffect, useState } from 'react'
import { connect } from 'react-redux';
import { closeOrderPopUp } from '../../action/hCommerce2';
import { getDefaultAnalyticsLabel } from '../../JS/utility';
import { sendAnalytics } from '../../../action/homeAction';
import { withTranslation } from 'react-i18next';
import { CMSPath } from '../../../config/constant';

const AccompanyingGuestFreeFormEditDetails = (props) => {

    const { t } = props;
    const [accompanyGuestData, setAccompanyGuestData] = useState(props.accompanyGuestDetails || {
        guestType: "",
        firstName: "",
        lastName: "",
        nameTitle: "",
        age: null
    });
    const [showList, setShowList] = useState(false)
    const listData = ["Mr.", "Mrs.", "Ms.", "Dr.", "Miss"]


    const handleAccompanyGuest = (key, value) => {
        setAccompanyGuestData({ ...accompanyGuestData, [key]: value })
    }

    const handleSave = () => {
        if (accompanyGuestData.guestType == "" || accompanyGuestData.nameTitle == "" || accompanyGuestData.firstName == "" || accompanyGuestData.lastName == "") {
            props.closeOrderPopUp(true, "Please enter all the fields to proceed", "", true)
            return;
        }

        if (accompanyGuestData.guestType == "child" && (accompanyGuestData.age == null || accompanyGuestData.age == "" || accompanyGuestData.age < 0)) {
            props.closeOrderPopUp(true, "Please enter all the fields to proceed", "", true)
            return;
        }

        props.save(accompanyGuestData);

        setTimeout(() => {
            setAccompanyGuestData({});
        }, 10);
    }

    React.useEffect(() => {

        if (accompanyGuestData.guestType == "child") {
            setAccompanyGuestData({ ...accompanyGuestData, "age": 0 })
        } else {
            setAccompanyGuestData({ ...accompanyGuestData, "age": null })
        }

    }, [accompanyGuestData.guestType])

    React.useEffect(() => {

        if (!accompanyGuestData.guestType) {
            setAccompanyGuestData({ ...accompanyGuestData, "guestType": "adult" });
        }

        if (props.accompanyGuestDetails && props.accompanyGuestDetails.age) {
            setAccompanyGuestData({ ...accompanyGuestData, "age": props.accompanyGuestDetails.age })
        }
    }, [])

    return (
        <Fragment>
            <div className="main-container" style={{ background: "url('theme/images/background/08MEDubai-Atrium.jpg') center center no-repeat", backgroundSize: "cover", backgroundAttachment: "fixed" }}>
                <header className="inner-pages w-footer subpages">
                    <a onClick={props.back} className="button-back"></a>
                    <div className="heading align-center">
                        <div class="splash-brand">
                            <img src={`${CMSPath}${props.logo}`} />
                        </div>
                        {/* <p className="bold">{props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.preCheckIn_heading') : t('check_in.guest_checkin')}</p> */}
                    </div>
                </header>
                <section class="widgets padding-0 margin-0 container-bg">

                    <div class="widget-header widget-header-checkin-inner">
                        { props.currentWidgetObj.widgetHeaderImageUrl && 
                            <div class="widget-header-img">
                                <img src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`} alt={props.currentWidgetObj.displayName} />
                            </div>
                        }
                        <div class="widget-header-title">{props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.preCheckIn_heading') : t('check_in.guest_checkin')}</div>
                    </div>

                    <div class="widgets" style={{ paddingBottom: "10rem" }}>
                        <div class="row padding-top-1 padding-bottom-0 padding-right-1 padding-left-1">
                        </div>
                        <div class="form-window">
                            <div class="form-window-heading">Add Companion</div>
                            <div class="row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1" style={{ borderRadius: "#ccc" }}>
                                <div class="form-row margin-bottom-1">
                                    <div class="optgroup">
                                        <input type="radio" name="ageSelection1" value="adult" checked={accompanyGuestData['guestType'] == "adult"} onClick={(e) => handleAccompanyGuest("guestType", e.target.value)} />Adult
                                        <input type="radio" name="ageSelection1" value="child" checked={accompanyGuestData['guestType'] == "child"} onClick={(e) => handleAccompanyGuest("guestType", e.target.value)} />Child
                                    </div>
                                </div>
                                <div className="form-row margin-bottom-2">
                                    <label>Salutation</label>
                                    <div className="custom-select align-left" >
                                        <div className="select-selected" onClick={() => { setShowList(!showList); }}>{accompanyGuestData['nameTitle'] !== "" ? accompanyGuestData['nameTitle'] : "Please Select"}</div>
                                        {showList && <div className="select-items">
                                            {listData.map((item) => {
                                                return (
                                                    <div onClick={() => { handleAccompanyGuest("nameTitle", item); setShowList(false) }}>{item}</div>
                                                )
                                            })}
                                        </div>
                                        }
                                    </div>
                                </div>
                                <div class="form-row margin-bottom-1">
                                    <label for="guest1FName">First Name *</label>
                                    <input name="guest1FName" id="guest1FName" type="text" value={accompanyGuestData.firstName} onChange={(e) => handleAccompanyGuest("firstName", e.target.value)} />
                                </div>
                                <div class="form-row margin-bottom-1">
                                    <label for="guest1LName">Last Name *</label>
                                    <input name="guest1LName" id="guest1LName" type="text" value={accompanyGuestData.lastName} onChange={(e) => handleAccompanyGuest("lastName", e.target.value)} />
                                </div>
                                {accompanyGuestData.guestType == "child" && <div class="form-row margin-bottom-1">
                                    <label for="guest1Age">Age</label>
                                    <div class="item-qty">
                                        <button disabled={accompanyGuestData.age <= 0 ? true : false} onClick={() => handleAccompanyGuest("age", +accompanyGuestData.age - 1)} >-</button>
                                        <input type="number" name="guest1Age" value={accompanyGuestData.age} onChange={(e) => handleAccompanyGuest("age", e.target.value)} />
                                        <button onClick={() => handleAccompanyGuest("age", +accompanyGuestData.age + 1)}>+</button>
                                    </div>
                                </div>}
                            </div>
                            <div class="row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
                                <div class="form-controls">
                                    <button class="primary w-100 margin-bottom-1" onClick={handleSave}><span class="fa fa-user-plus margin-right-1"></span>{props.accompanyGuestDetails ? "Update" : "Add Companion"}</button>
                                    <button class="secondary w-100 margin-bottom-1" onClick={props.cancel}>Cancel</button>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>
            </div>
        </Fragment>
    )
}

const mapStateToProps = state => {
    return {
        cardChecksData: state.store2.cardChecksData,
        accompanyGuests: state.store2.accompanyGuests,
        guestDetail: state.store.home.guestDetails,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        currentHomePage: state.store2.currentHomePage,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
    }
}
export default connect(
    mapStateToProps,
    {
        closeOrderPopUp,
        sendAnalytics
    }
)(withTranslation('translations')(AccompanyingGuestFreeFormEditDetails));